import { render } from "./MyTicketsIndex.vue?vue&type=template&id=6a373ecc"
import script from "./MyTicketsIndex.vue?vue&type=script&lang=js"
export * from "./MyTicketsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script